import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { SeoHead } from 'modules/seo';
import { ChecktypeDocumentsUploadType } from 'modules/entities/modules/documents';

import { UploadDocument } from '../UploadDocument';
import { UploadInfo } from '../UploadInfo';
import { UploadPage } from '../UploadPage';
import { UploadDescription } from '../UploadDescription';

export const UploadZUESPage = () => {
    const intl = useIntl();

    return (
        <UploadPage>
            <SeoHead title={intl.formatMessage({ id: 'page.uploadZUES.seoTitle' })} />
            <UploadInfo
                title={<FormattedMessage id="page.uploadZUES.title" />}
                description={<FormattedMessage id="page.uploadZUES.description" />}
                subTitle={<FormattedMessage id="page.uploadDocument.info.title" />}
                listItems={[
                    <FormattedMessage id="page.uploadDocument.info.item-1" />,
                    <FormattedMessage id="page.uploadDocument.info.item-2" />,
                    <FormattedMessage id="page.uploadDocument.info.item-3" />,
                    <FormattedMessage id="page.uploadDocument.info.item-4" />,
                ]}
            />
            <UploadDocument type={ChecktypeDocumentsUploadType.ZUES} />
            <UploadDescription>
                <FormattedMessage id="page.uploadZUES.infoText" />
            </UploadDescription>
        </UploadPage>
    );
};
